module.exports = __webpack_public_path__ + "static/media/Offices-2.63674840.webp";